import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    Routes,
    RouterModule
} from '@angular/router';

import { HomeComponent } from './public/home/home.component';
import { AboutComponent } from './public/about/about.component';
import { ContactComponent } from './public/contact/contact.component';
import { HeatingComponent } from './public/heating/heating.component';
import { CoolingComponent } from './public/cooling/cooling.component';
import { PlumbingComponent } from './public/plumbing/plumbing.component';
import { HeatPumpComponent } from './public/heat-pump/heat-pump.component';
import { NotFoundComponent } from './public/not-found/not-found.component';

const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'about', component: AboutComponent },
    { path: 'contact', component: ContactComponent },
    { path: 'heating', component: HeatingComponent },
    { path: 'cooling', component: CoolingComponent },
    { path: 'plumbing', component: PlumbingComponent },
    { path: 'heat-pumps', component: HeatPumpComponent },
    { path: '**', component: NotFoundComponent } // 404 Error
];

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        RouterModule.forRoot(routes, {
            onSameUrlNavigation: 'reload',
            scrollPositionRestoration: 'enabled'
        })
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }
